import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { captureTrafficSource } from "./utils/analyticsHelper";
import { initMetaPixel } from "./config/metaPixel";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://c5fb6596fa1f83c994abb33cbe8c8ea6@o4509718631677952.ingest.us.sentry.io/4509718634233856",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});



captureTrafficSource();
initMetaPixel();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(<App />);

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/serviceWorker.js', {
      scope: '/'
    })
      .then((registration) => {
        console.log('Service Worker registered successfully:', registration);
        console.log('Service Worker scope:', registration.scope);
        
        // Force update if there's already a waiting service worker
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          window.location.reload();
        }

        // When a new service worker is found, activate it immediately
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New build is ready — skip waiting and reload to get it
              newWorker.postMessage({ type: 'SKIP_WAITING' });
              window.location.reload();
            }
          });
        });
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
